import React from "react";
import { useTranslation } from "react-i18next";
import Search from "../../../../../../../../../components/Common/Search/Search";
import { LiveOrdersBlockedProductFilter } from "../../../services/types";
import LiveOrdersBlockedItemsFilterButton from "./LiveOrdersBlockedItemsFilterButton";

interface Props {
	selectedFilter: LiveOrdersBlockedProductFilter;
	setSelectedFilter: React.Dispatch<React.SetStateAction<LiveOrdersBlockedProductFilter>>;
	setSearch: (search: string) => void;
	blockedCategoriesAmount: number;
	blockedProductsAmount: number;
}

const LiveOrdersBlockedItemsFiltersModal = ({
	selectedFilter,
	setSelectedFilter,
	setSearch,
	blockedCategoriesAmount,
	blockedProductsAmount,
}: Props): JSX.Element => {
	const { t } = useTranslation();
	const filters: { title: string; id: LiveOrdersBlockedProductFilter; amount?: number }[] = [
		{
			id: LiveOrdersBlockedProductFilter.PRODUCTS,
			title: t("modules.live_order.field.products.title"),
		},
		{
			id: LiveOrdersBlockedProductFilter.BLOCKED_PRODUCTS,
			title: t("modules.live_order.field.blocked_products.title"),
			amount: blockedProductsAmount,
		},
		{
			id: LiveOrdersBlockedProductFilter.CATEGORIES,
			title: t("modules.live_order.field.categories.title"),
		},
		{
			id: LiveOrdersBlockedProductFilter.BLOCKED_CATEGORIES,
			title: t("modules.live_order.field.blocked_categories.title"),
			amount: blockedCategoriesAmount,
		},
	];

	return (
		<div className="d-flex flex-column gap-4 live-orders-blocked-items-filters-modal">
			<div className="d-flex flex-wrap gap-2">
				{filters.map((filter) => (
					<LiveOrdersBlockedItemsFilterButton
						key={filter.id}
						id={filter.id}
						title={filter.title}
						isSelected={selectedFilter === filter.id}
						setSelectedFilter={setSelectedFilter}
						amount={filter.amount}
					/>
				))}
			</div>
			<Search onSearch={setSearch} placeholder={t("lib:common.word.search")} />
		</div>
	);
};

export default LiveOrdersBlockedItemsFiltersModal;
